// src/api/index.js
//
// Transport: ``createAppTransport`` picks per NODE_ENV — proxy (same-origin
// `/api/browser`) in prod, direct (pam.wsq.io) in dev/test. Direct mode
// pulls Beacon credentials from ``REACT_APP_BEACON_*`` env vars
// (gitignored ``.env.local``) so the production bundle ships zero Beacon
// credentials. See @1823-partners/core/src/api/createAppTransport.js.
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

const api = createAppTransport({ axios, appName: 'browser' });

// UI hint only — the server enforces every gate via @require_permission.
// Browse/download need 'browser.files:read'; the upload drop-zone needs
// 'browser.files:write'.
export const getMyPermissions = () => api.get('/my-permissions');

/**
 * Fetches a list of files from the file browser API.
 * @param {string} path - (Optional) The directory path to list files from.
 */
export const fetchFiles = (path = '') =>
  api.get('/files', { params: { path } });

/**
 * Uploads a file to the file browser API.
 * @param {File|File[]} files - The file(s) to be uploaded.
 * @param {string} path - (Optional) The destination path in the file browser.
 */
export const uploadFile = (files, path = '') => {
  const formData = new FormData();

  // Handle both single file and multiple files
  if (Array.isArray(files)) {
    files.forEach(file => {
      formData.append('files', file);
    });
  } else {
    formData.append('files', files);
  }

  const endpoint = `/upload${path ? `?path=${encodeURIComponent(path)}` : ''}`;
  return api.post(endpoint, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * Downloads a file from the file browser API.
 * @param {string} path - The full path of the file to be downloaded.
 */
export const downloadFile = (path) =>
  api.get('/download', {
    params: { path },
    responseType: 'blob',
  });

// Default export: the shared axios-shaped transport. Consumed by
// ``useGridConfigs`` (per-user grid layout persistence) which talks to the
// ``/grid-configs`` endpoints directly via this client.
export default api;
